var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 22,
    viewBox: "0 0 22 22",
    width: 22,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.5870128 14.4154399c-2.23025549 1.0654062-4.98238111.6744732-6.82965349-1.1727992-2.34314575-2.3431458-2.34314575-6.14213564 0-8.48528139s6.14213559-2.34314575 8.48528139 0c1.8472724 1.84727238 2.2382054 4.599398 1.1727992 6.82965349l3.0698415 3.0698414c.7810486.7810486.7810486 2.0473786 0 2.8284272s-2.0473786.7810486-2.8284272 0zm.2414143-2.5870128c1.5620972-1.5620971 1.5620972-4.09475706 0-5.65685422-1.5620971-1.56209717-4.09475706-1.56209717-5.65685422 0-1.56209717 1.56209716-1.56209717 4.09475712 0 5.65685422 1.56209716 1.5620972 4.09475712 1.5620972 5.65685422 0z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchWhite);
export default __webpack_public_path__ + "static/media/search_white.584ff730bd7ac3318b47bf0237fce776.svg";
export { ForwardRef as ReactComponent };